import {GitAPI} from '../shared/git'
import '../widgets/element'
import '../widgets/scrim-info'

let PLAYER = null

tag scrim-el

	def trigger
		Imba

	get audio
		PLAYER.audio!
	
	get timeline
		PLAYER.timeline!

	get player
		PLAYER

	get view
		PLAYER.view!

	get branch
		PLAYER.branch!
	
	get model
		branch.model!

tag scrim-terminal-button < scrim-el

	def toggle
		player.console!.setEnabled(!player.console!.enabled!)

	def render
		<self[us:none].tool @click.stop.prevent=toggle> <svg src="svg/terminal.svg" >


tag scrim-slider
	prop min = -50
	prop max = 50
	prop step = 1
	prop value = 0

	css .thumb h:4 w:2 bg:blue7 d:block pos:absolute x:-50% t:50% y:-50% rd:sm
	css .thumb b x:-50% l:50% b:100% w:5 ta:center pos:absolute d:block fs:xxs c:gray4
	css & @before content: " " pos:absolute d:block inset:0 my:1 rd:1px bg:gray4

	def mount
		schedule!

	def update val
		value = val
		emit('update',val)

	<self[h:4] @touch.lock.fit(min,max,step)=update(e.x)>
		<.thumb[l:{100 * (value - min) / (max - min)}%]>


tag scrim-editor-menu < scrim-el

	def setVolume value,e
		settings.volume = value
		audio.setVolume(value)

	def setSpeed value
		settings.playbackRate = value
		timeline.setPlaybackRate(value)

	def setFontSize value
		settings.fontSize = value
		view.setUserFontSize(value)

	def forkScrim
		let data = player.clone!
		data.title = "Fork of {data.title.replace('Fork of','')}"
		let scrim = window.Player.Scrim.build(data)
		await scrim.persist!
		document.location.href = "/scrim/{scrim.id}"

	def cloneScrim
		let scrim = model
		let buf = branch._stream._buffer.slice(0)
		let res = await window.$api.post("/scrims/{scrim.id}/clone",buf)
		console.log 'returned',res,buf
		if res and res.id
			document.location.href = "/scrim/{res.id}"
		self

	def copyLink
		let anchor = player.getAnchor!
		# console.log anchor
		try
			# let data = new ClipboardItem({ "text/plain": anchor.href })
			let res = await global.navigator.clipboard.writeText(anchor.href)
			# console.log 'clipped?',res

	def mount
		schedule!
		audio.setVolume(settings.volume or 1)
		timeline.setPlaybackRate(settings.playbackRate or 1)
		view.setUserFontSize(settings.fontSize or 13)

	css label fs:xs/1.1
	css .slider d:vflex
		label d:hflex mb:1 jc:space-between

	def downloadZip
		let snap = player.toRunStaticSnapshot!
		let name = "{player.branch!.id!}"
		let res = await window.fetch("/download-scrim.zip?name={name}",
			headers: { "Content-Type": "application/json"},
			mode: 'cors',
			method: 'POST',
			body: JSON.stringify(snap)
		)
		let blob = await res.blob!
		let url = window.URL.createObjectURL(blob)
		let a = document.createElement('a')
		a.href = url
		a.download = "project.zip"
		document.body.appendChild(a)
		a.click!
		a.remove!
		return
		
	get can-edit-slides?
		const teacher? = store.user..roles..includes('teacher')
		const has-slides? = global.window.SP.widgets!.array!.some(do $1.data!.type == 'slide')

		teacher? and has-slides?

	def render
		let volume = audio.getVolume!
		let pbr = timeline.playbackRate!
		let fs = view.fontSize!
		let ufs = view.userFontSize!

		<self>
			<div.dropdown.br[c:gray5 @hover:blue5] tabIndex=-1>
				<svg.feather src="svg/settings.svg" [$svg-size:16px m:4px va:baseline]>
				<.menu[b:100% r:0 l:auto t:auto c:gray8 mb:2 mr:2]>
					# <.item.only-owner @click=forkScrim> "Fork Scrim"
					# <.item.only-owner @click=cloneScrim> "Clone whole Scrim"
					# <hr>
					# <.shortcut data-shortcut='space'> "pause / resume"
					# <.shortcut data-shortcut='ctrl shift ←'> "slower playback"
					# <.shortcut data-shortcut='ctrl shift →'> "faster playback"
					# <.shortcut data-shortcut='→'> "go forward 10s"
					# <.shortcut data-shortcut='←'> "go back 10s"
					<.item @click=downloadZip> "Download as zip"
					if can-edit-slides?
						<.item @click=(window.location.hash = "#edit-slides")> "Edit slides"
					<.item.only-owner @click=copyLink> "Copy contextual link"
					<hr>
					
					<.item.slider>
						<label>
							<span> "Font Size"
							<span> fs + 'px'
						<scrim-slider @update=setFontSize(e.detail) min=8 max=24 step=1 value=ufs>
					
					<.item.slider>
						<label>
							<span> "Speed"
							<span> pbr + 'x'
						<scrim-slider @update=setSpeed(e.detail) min=0.4 max=4 step=0.1 value=pbr>

					<.item.slider>
						<label>
							<span> "Volume"
							<span> volume
						<scrim-slider @update=setVolume(e.detail) min=0 max=1 step=0.01 value=volume>

tag scrim-like-button

	def toggle
		# set view
		let url = "/scrims/{data.id}/view"
		let val = data.liked? ? 0 : 1
		let res = await api.post(url,likes: val)
		# console.log 'call',url,res
		if res.data
			data.view = res.data
			render!

	css self
		&.checked
			c:yellow4
			>>> path fill:currentColor
			@hover >>> path fill-opacity:0.4

	<self @click=toggle .checked=data.liked?>
		<svg.feather src="svg/bookmark.svg" >

tag scrim-player-controls	
	<self[d:contents]>
		<scrim-like-button.tool[d@embedded:none] data=store.scrim>
		<scrim-editor-menu>
		<app-toggler.tool.toggler[d@embedded:none] bind=lmods['show-drawer']> <svg.feather src="svg/menu.svg" >

tag scrim-user-avatar
	<self> <.avatar>

tag scrim-comment
	get author do data.user

	<self[d:block] data-parent=data.parent_id>
		<div[d:grid gtc:40px 1fr g:16px mb:6]>
			<img[w:100% rd:100 bxs:xs] src=author.avatar-url!>
			<div>
				<div[fs:xs]>
					<span[fw:600]> author.displayName
					<span[c:gray6 ml:2 fw:500]>
						if $web$	
							data.ts.toTimeAgo!
						else	
							data.ts.toString!
				<div[fs:md/1.5 w:<700px]> data.body
		<.replies[px:12]> for item in data.replies
			<scrim-comment data=item>


tag scrim-page
	css .stats c:gray6 fs:xs/1.4 fw:500 d:hflex ai:center
		.stat .link c:blue7 td:none @hover:underline
		@!600 flw:wrap

	css .stat + .stat @before content: " | " d:inline-block o:0.3 mx:2

	css
		bg:#1f272a
		d:block pos:absolute inset:0 t:1hdh @embedded:0 @mini-header:30px

		1drw:320px
		$bottom-pad: 0px
		$scrim-min-height: 440px
	
	css self @embed
		$bottom-pad: 0px
		$sheet d:none

	css $frame
		$height: 100%
		h:$height
		bg:$ide-bg
		.SpaceView pos:absolute inset:0 w:auto h:auto
			@show-drawer @pin-drawer r@700:1drw

		$drawer
			pos:absolute b:0 r:0 t:auto h:40% my:10 mr:4
			min-height:260px
			@700 max-width:70vw min-height:460px
			bg:white rd:lg rdbr:0 zi:670 bxs:xxs,lg w:1drw
			pe:none o:0 scale:0.6 tween:all 0.2s quart-out
			origin:100% 100%

			@show-drawer o:1 scale:1 pe:all
				@pin-drawer rd:0 m:0 bxs:none
					w:100% @700:1drw
					h:70% @700:100%

			# @pin-drawer rd:0 m:0 h:100% x:100% bxs:none
			#	@show-drawer x:0
			# @peek-drawer
			#	min-height:110px h:110px m:4 mb:10 rd:lg bxs:xxs,md o:1 scale:1 pe:all

		$peek
			pos:absolute b:10 r:4
			bg:white rd:lg rdbr:0 zi:900 bxs:xxs,lg w:1drw <80vw
			pe:none o:0 scale:0.3 tween:all 0.3s circ-in-out,opacity 0.3s linear
			origin:100% 100%
			@peek-drawer o:1 scale:1 pe:all
			@show-drawer o:0 scale:0.3 pe:none

	css $overlay
		d:vflex pos:absolute inset:0 ja:center bg:black/50 zi:799 c:white
		backdrop-filter:blur(8px)

	css & @not(.was-scrolling) $sheet@hover
		$more .action
			suffix: "SCROLL FOR MORE" pe:none
			bc:clear y:12px c:gray5

	css .overlay-text max-width:700px m:4

	def hydrate
		innerHTML = ''
		schedule!
		render!
		

		# auto-show collapsed drawer in bottom left
		# for a few seconds if it is not toggled ON
	
	get scrim do store.scrim
	get teacher do scrim.user
	get course do store.course
	get comments do scrim.messages or []
	get embed-fullscreen-link
		return "#" unless $web$
		return window.location.origin + window.location.pathname

	has-access\boolean
	users-only\boolean
	members-only\boolean
	guest\boolean
	past-due\boolean
	not-enrolled\boolean

	def setup-github-blocks # "
		const parent = window.parent
		# console.log "message sent to opener", parent
		window.addEventListener('message', &, no) do(e)
			return unless e.origin == 'http://localhost:4000' or e.origin == 'https://blocks-sandbox.githubnext.com'
			if e.data.action == "publish"
				try await scrim.branch.publish! if !scrim.published_at
				return

			const res = await api.post "/scrims/{scrim.id}", {
				title: e.data.title
				description: e.data.description
				privacy: e.data.privacy
			}
			scrim.$patch(res.data) if res.data
			imba.commit!
			blocks_created = {}
			def focusFile(path)
				document.querySelector(".EntryHead[data-path=\"/{path}\"]")..click!

			def createFolder(path)
				const parts = path.split '/'
				const name = parts[-1]
				const folder = App.space!.fs!.findDir(path)
				if parts.length == 1
					blocks_created[path] ||= folder or App.space!.fs!.mkdir(name)
				else
					const parent = createFolder(parts.splice(0, parts.length - 1).join('/'))
					blocks_created[path] ||= folder or parent.mkdir(name)

			def createFile(path, content)
				const parts = path.split '/'
				const name = parts[-1]
				if parts.length == 1
					const file = App.space!.fs!.find(name)
					if file
						file.rename("old_{name}")
						file.rm!
						const newfile = App.space!.fs!.mkfile(name, {body:content})
						# App.space!.agent!.file = do newfile
						# App.space!.view!.editor!.focus!
					else
						App.space!.fs!.mkfile(name, {body:content})
				else
					const parent = createFolder(parts.splice(0, parts.length - 1).join('/'))
					parent.mkfile(name, {body: content})

			# for file in e.data when file.type == 'blob'
			for file in e.data.files
				createFile(file.path, file.content)
			if e.data.files.length == 1
				setTimeout(&, 0) do focusFile e.data.files[0].path
			imba.commit!

		parent.postMessage({id:scrim.id, url: document.location.href, mounted: yes}, '*')


	def mount
		init! if window.Player and !player
		schedule!
		render!
		if $web$
			await import('../clients/player')


	def init
		window.flags.add('noscroll')
		let Player = window.Player
		unless window.Player
			return

		# imba1 land - beware of method calls
		let model = new Player.Scrim(scrim)
		
		
		player = new Player(model, api: Player.API)
		# console.log 'scrim model!',model,player
		PLAYER = player
		document.scrollingElement.scrollTop = 0

		view = player.view!
		window.App = view
		await player.setup!

		$frame.appendChild(view.dom!)
		await player.load!

		window.addEventListener('beforeunload') do(e)
			let unsaved = scrim.children.filter do $1.local?
			if unsaved.length
				e.preventDefault!
				e.returnValue = ''

		document.addEventListener('click') do(e)
			# Ensure click originates from a link in our google slides
			const localName = e.target.localName
			const parentNode = e.target.parentNode
			return unless localName === 'path' and parentNode..localName === 'a' and parentNode..parentNode..localName === 'g'

			player.actions().get('pause').exec()

		if scrim.locked
			player._unauthorized = yes

		def setup-git-syncing
			const fs = App.space!.fs!
			const widgets = App.space!.widgets!

			let {owner, repo, type, ref, filePath = "", source, url, refFetched} = scrim.metadata.git
			# console.log "::NO REFFFF", ref if !ref
			const git = new GitAPI({owner, repo, filePath, ref, type, source})
			if !refFetched
				const ref = await git.getRef!
				scrim.metadata.git.refFetched = yes

				let url = "https://{git.source}/{owner}/{repo}"
				url += '/-' if source == 'gitlab.com'
				url += "/{type}/{ref}/{filePath}"

				# pin a commit for the scrim
				scrim.metadata.git.ref = ref
				scrim.metadata.git.url = url
				try api.post
					"/scrims/{scrim.id}",
					{ metadata: scrim.metadata }
				imba.commit!
			# ref ||= await GitAPI.getRef(owner, repo)
			const file = await git.loadFileContent({fullPath: filePath})
			if file
				# filePath points to a file.
				return fs.mkfile(filePath.split('/')[-1], {body: file})

			const initial-tree = await git.loadFolderContent({fullPath: filePath})

			def createFolder(folder, parent)
				let fsFolder
				if parent
					fsFolder = parent.mkdir(folder.path, {fullPath: folder.fullPath})
				else
					fsFolder = fs.mkdir(folder.path, {fullPath: folder.fullPath})

			def createItemsInScrim(tree, parent)
				for file in tree
					if file.isDirectory
						createFolder(file, parent) unless fs.findDir(file.fullPath)
					elif !fs.find(file.fullPath)
						(parent or fs).mkfile(file.path, {body:'', fullPath: file.fullPath})

			def loadFile(e)
				# const {fullPath, id, path} = e.detail
				const file = widgets.first do $1._id == e.detail.id
				const res = await git.loadFileContent e.detail
				file.replaceBody(res)
				file._data.fetched = yes
				# removing fullPath ensures the event isn't even triggered
			def loadFolder(e)
				# const {fullPath, id} = e.detail
				const res = await git.loadFolderContent e.detail
				const parent = widgets.first do $1._id == e.detail.id
				# console.log "::non poarent", fullPath, id, parent unless parent
				createItemsInScrim(res, parent)
				parent._data.fetched = yes if parent

			window.addEventListener 'gitLoadFile', loadFile
			window.addEventListener 'gitLoadFolder', loadFolder

			createItemsInScrim(initial-tree)
			# load content of focused files
			const focused = App.space!.agent!.file!
			loadFile({detail: focused._data}) if focused and !focused.body!


		setup-git-syncing! if scrim..metadata..git
		window.$api.track("Cast", "Git Repo Loaded", "{scrim.metadata.git.owner}/{scrim.metadata.git.repo}") if scrim..metadata..git
		window.$once('loaded').then do
			return if player._unauthorized
			# if scrim.locked
			#	return player.view!.dispose!

			for item in store.branches when item.note?
				let branch = Player.Scrim.wrap(item)
				player.trunk!.loadChildBranch(branch)

			if store.query.t
				player.timeline!.seek(store.query.t)

			elif store.query.a
				player.gotoAnchor(store.query.a)
				# player.timeline!.seek(store.query.t)

			elif let view = store.scrim.view
				# only makes sense when we are playing back?
				if view.progress <= 0.98
					player.timeline!.setProgress(view.progress)

			try setup-github-blocks! if window.parent


		self
	
	def rendered
		if $web$ and window.Player and !player
			init!
		if view
			has-access = window.flags.contains('mod-has-access')
			users-only = window.flags.contains('mod-users-only')
			members-only = window.flags.contains('mod-members-only')
			guest = window.flags.contains('mod-guest')
			past-due = window.flags.contains('mod-past-due')
			not-enrolled = window.flags.contains('mod-not-enrolled')
			view.render!


	def editMetadata target = scrim
		imba.mount <scrim-edit-dialog data=target>
	
	def scrimEnded
		return if window.flags.contains('mod-no-next-up')

		if scrim.next
			# Dont show on your own scrims
			return if scrim.uid == store.uid
			return if (scrim.next.released_at and scrim.next.released_at > Date.now())

			if !lmods['show-drawer']
				$cancelNext = $peek.queueNext!
			else
				$cancelNext = $drawer.queueNext!
		elif course and course.id != 'gfrontend' and !scrim.note?
			# Course is over - congratulate the user
			imba.mount <completed-course-dialog course=course>
	
	def scrimBranched
		if $cancelNext
			$cancelNext!
			$cancelNext = null

	def open target
		if target isa Scrim
			if target.branch
				target.branch.enter!
			self

	def enroll
		return unless course..id
		await window.$api.post("/course/{course.id}/enroll")
		await window.reloadUserData!
		document.location.reload!
		
	def showenv
		window.location.hash == '#env' ? window.location.hash = '' : window.location.hash = 'env' 

	def render
		<self>
			<div @hotkey('command+shift+e').showenv()>
			<$frame
				@editscrim=editMetadata(e.detail)
				@scrimend=scrimEnded
				@scrimbranch=scrimBranched
				@open=open(e.detail)
			>
				<[d:none @mini-header:flex bgc:#2b3039 c:#63748b jc:space-between pos:absolute t:-30px l:0 r:0 h:30px]>
					<a.logo[all:unset d:hflex cursor:pointer a:center h:8 px:2] href="https://scrimba.com" target="_blank">
						<app-logo[d:inline-block h:10px m: 0 1 0 2 a:center]>
						<p[a:center mb:0.25rem]> <b[fs:0.75rem]> "scrimba"
					<a[all:unset d:hflex cursor:pointer fs:1rem px:2 a:center h:8] href=embed-fullscreen-link target="_blank">
						<span> "Watch in {<b> "fullscreen" }"

				if has-access === no and !window.storageBlocked
					<div$overlay>
						if past-due
							<div.overlay-text>
								"Your payment is past due"
								<a.button[mt:8] href='/mybilling'> "Go to billing to fix this"
						elif members-only and !guest
							<div.overlay-text>
								"To see this lesson you need to be a subscriber"
								<a.button[mt:8] href='#join'> "Join Scrimba"
						elif not-enrolled and !guest
							<div.overlay-text[ta:center]>
								"Liking the course? Enroll so you can access it any time from your dashboard."
								<a.button[mt:8] @click=enroll> "Enroll"
						elif users-only or guest
							<div.overlay-text[ta:center]>
								"To see this lesson you need to be logged in. Joining Scrimba is free and gives you access to 20+ courses."
								<a.button[mt:8] href='#sign-up'> "Sign up"
						else
							<div.overlay-text[ta:center]>
								"You don't have access to this scrim. If you think this is an error, please contact us."
								<a.button[mt:8] href='https://scrimba.helpscoutdocs.com/' rel="noreferrer" target="_blank"> "Support center"

				if $web$ and !window.flags.contains('mod-no-next-up')
					<scrim-info$drawer data=scrim>
					if !scrim..next..released_at or (scrim.next.released_at < Date.now())
						<scrim-peek-info$peek data=scrim>

global css .frame .SpaceView
	@unauthorized pe:none
		* pe:none

	c:gray5
	.ViewportOverlay
		.PlayButton
			d@no-big-play:none
			bg:blue4/90 @hover:blue4
			svg fill:white w:14 h:14 ml:1 tween:all 0.1s ease-out
			scale@hover:1.03 cursor:pointer
			@hover svg scale:1.1

	.tool c:gray5 @hover:blue5
		d:hflex ja:center
		$svg-size:16px
		svg va:top pe:none
		&.toggler.checked c:blue6 @hover:blue5
			filter:drop-shadow(0 0 4px blue5/30)
	
	.tool.blue c:blue5 @hover:blue4
	.tool.red c:red5 @hover:red4
	.tool.green c:green5 @hover:green4
	.tool.yellow c:yellow5 @hover:yellow4
	.tool.neutral c:gray5 @hover:blue5
	
	.tool svg pe:none

	$space-bg: #212329 # 282f33
	$panel-bg: #2B2D34
	$editor-bg: $space-bg
	
	$panel-hr: #1e2124
	$space-hr: #32373b
	$editor-hr: #32373b
	$panel-heading: #6e7a82

	&.ps-editing,&.note
		$panel-bg: #272723
		$space-bg: #1f1e1c
		$editor-bg: $space-bg
		$panel-hr: #3b3a35
		$space-hr: #3b3a35
		$panel-heading: #82806e

	.track-placeholder fl:1 w:auto h:1 pe:none mr:54px

	.InspectorView pe:none
	&.showInspector .InspectorView pe:auto

	.button us:none

	.titlebar bwb:0px px:2 d@no-execute:none
		.path fs:sm/1 fw:500
		.tool c:gray5 @hover:blue5 us:none
			$svg-size:16px
			svg m:4px va:top
		.avatar h:6 w:6 ml:2 rd:sm bg:$avatar bgs:cover
		.tool-button h:6 px:2 rd:sm d:hflex ja:center fs:xs/1 tt:uppercase fw:600 cursor:pointer c:white
			bg:gray7 ml:2 bd:1px solid clear us:none
			b fw:inherit
			@before ml:-1 fs:md/1 c:white tween:all 0.1s ease-out mr:1
		.tool-button.run bg:green6 @hover:green5 c:white
			@before mr:0
		
		.tool-button.toggleable
			@before d:none
			bg:gray7 bc:gray7 c:white
			&.off bg:gray7/10 @hover:gray7/25 bc:gray7 c:gray5 @hover:gray3
		# @hover @before c:green9

	.BrushupView mb:0px d:vflex a:stretch
		overscroll-behavior:none
		header p:2 h:auto order:6 bg:gray3 us:none
		.buttons d:hflex a:center ml:auto
		.button px:2 py:1 fs:xs/1.2 rd:sm m:1 bwb:1px
		.button.red bg:red5 @hover:red6 @active:red7
		.button.green bg:green5 @hover:green6 @active:green7
		.TimelineRegionCanvas h:120px
		footer bg:gray2 order:-10 us:none
		.hint em bg:white px:2 py:1 fs:xxs/1 bxs:xs bdb:none c:gray6 tt:uppercase fw:600

# temporary css overrides for player
global css .timeline-controls.timeline-controls
	overscroll-behavior:none
	touch-action:none

	@unauthorized d:none
	.tools.right min-width:24px j:flex-end
	# .tool.neutral c:gray5 @hover:blue5
	# .tool.green c:green5 @hover:green4
	.marker-desc pe:auto
	.marker-desc .time c:gray5
	.tl.in-chain pe:auto
	.tool d:hflex ja:center
	.tool svg m:0 va:top
	.tool.sm fs:16px --svg-size:12px
	.tool.lg --svg-size:24px
	.tool.hide o:0 pe:none mr:-1em

	.time ff: "Helvetica Neue",Verdana fw:500
		c.red: red4

	.tool.rec
		d@embedded:none
		@before,@after
			pos:absolute content:" "
			inset:3px bg:red5 pe:none
			tween:all 0.2s quart-out
		@before bg:white rd:0.5em
		@after bg:red5 rd:0.5em scale:0.5 
		@hover @after scale:0.8

		@not(.active)
			@before scale: 0.5
			@hover @after scale:0.6
			@hover @before scale:1

		&.active
			@before scale:0.5
			@after rd:2px scale:1

	.pb-controls
		pos:absolute r:100% d:hflex t:50% y:-50% px:1.5 fs:18px ja:center
		.tool fs:18px
		.tool.sm --svg-size:12px
		.toolgroup d:contents

	.pb-controls.level0
		min-width:54px px:1
		.tool --svg-size:24px fs:24px
		.tool.sm --svg-size:18px fs:20px

	.tl.yellow
		.tool.neutral c:yellow3/60 @hover:yellow3
	
	.tl.not-in-chain pe:none
		.tool pe:none
		.marker-desc pe:none

	.tl @not(.level0)
		@not(.is-current) > .pb-controls o:0 pe:none
	
	._graph-root pos:absolute l:60px pe:all
	
	._graph-marker
		$marker-color: blue4 .yellow:yellow4 .red:red4

	._graph-timeline
		$track-bg: #2d3748
		$timeline-color: blue4 .yellow:yellow4 .red:red4

	.marker-controls d:hflex ja:center pl:0.5
		.tool fs:16px

global css .tippy-tooltip
	&.tool-theme @force c:gray7
		.tippy-backdrop bg:white/95

global css .Overlay
	d:flex inset:0 pos:fixed zi:3000
	> .backdrop pos:absolute zi:0 inset:0
	> .floating zi:1 bxs:lg rd:sm m:auto pos:absolute

	.Menu.floating
		w:220px <300px
		pe:none o:0 scale:0.96
		tween:all 0.2s quart-out 
		bg:white/95 bxs:lg py:2 px:2 rd:lg mt:2
		fs:sm

		&.uxa-show o:1 scale:1 pe:all

		.MenuItem,.action,.item
			i d:none
			td:none d:hgrid p:1 px:3 fw:500 cursor:pointer rd:md
			c:gray7 fs:inherit
			tween:all 0.3s quart-in
			@hover bg:gray6/5 c:gray8 tween:all 0.3s quart-out

		hr d:block bd:none h:1px bg:gray5/30 my:1 mx:-2

	.Dialog
		pe:none o:0 scale:0.96
		tween:all 0.2s quart-out 
		bg:white/99 bxs:lg py:2 px:2 rd:lg mt:2
		fs:sm l:50% t:25% x:-50%
		min-width: 40vw

		&.uxa-show o:1 scale:1 pe:all
		.footer d:hflex j:flex-end
		.body px:6 py:4
		.Button tt:uppercase px:3 py:2 bg:gray4 rd:md m:1 c:gray7 fw:500 fs:sm- bd:1px solid gray6
			bg:white/20 @hover:white
			bc:gray3 @hover:gray7
			c:gray7 @hover:gray9
			
		.SelectField
			hr,span d:none
			d:vflex
			label order:0 fw:500 c:blue7
			select order:1 p:2 px:3 rd:sm bd:1px solid gray5
		
		.TextField
			hr,span d:none
			d:vflex
			label order:0 fw:500 c:blue7
			input order:1 p:2 px:3 rd:sm bd:1px solid gray5
